/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S10_Li2_LabelInputs */

const tr_onbilgi_s10_li2_label = /** @type {(inputs: Onbilgi_S10_Li2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veri Şifreleme:`)
};

const en_onbilgi_s10_li2_label = /** @type {(inputs: Onbilgi_S10_Li2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data encryption:`)
};

const de_onbilgi_s10_li2_label = /** @type {(inputs: Onbilgi_S10_Li2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenverschlüsselung:`)
};

const ru_onbilgi_s10_li2_label = /** @type {(inputs: Onbilgi_S10_Li2_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шифрование данных:`)
};

/**
* | output |
* | --- |
* | "Data encryption:" |
*
* @param {Onbilgi_S10_Li2_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s10_li2_label = /** @type {((inputs?: Onbilgi_S10_Li2_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S10_Li2_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s10_li2_label(inputs)
	if (locale === "de") return de_onbilgi_s10_li2_label(inputs)
	if (locale === "ru") return ru_onbilgi_s10_li2_label(inputs)
	return tr_onbilgi_s10_li2_label(inputs)
});